import { useExecutiveQuery } from 'features/executive/shared/hooks/use-executive-query'
import PerformanceApi from 'api/executive/performance.api'
import type {
  AppointmentsResponse,
  GetAppointmentsParams,
} from 'api/executive/executive.types'

export function useAppointments() {
  return useExecutiveQuery<GetAppointmentsParams, AppointmentsResponse>(
    'performance.appointments',
    PerformanceApi.getAppointments,
    (f) => {
      if (!f.dateRange?.start || !f.dateRange?.end) return null
      return {
        dateFrom: f.dateRange.start,
        dateTo: f.dateRange.end,
        branchId: f.branchId ?? undefined,
        doctorId: f.doctorId ?? undefined,
        patientType: f.patientType ?? undefined,
        appointmentStatus: f.appointmentStatus ?? undefined,
      }
    }
  )
}
